"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var ExternalLink = function ExternalLink() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M1408 928v320q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-320q0-14 9-23t23-9h64q14 0 23 9t9 23zm384-864v512q0 26-19 45t-45 19-45-19l-176-176-652 652q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l652-652-176-176q-19-19-19-45t19-45 45-19h512q26 0 45 19t19 45z"
  }));
};

ExternalLink.displayName = 'ExternalLink';
var _default = ExternalLink;
exports["default"] = _default;
ExternalLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ExternalLink"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/ExternalLink.js"] = {
    name: "ExternalLink",
    docgenInfo: ExternalLink.__docgenInfo,
    path: "src/ExternalLink.js"
  };
}